<div class="modal-backdrop-custom" *ngIf="isModalOpen && !isModalHostMode" (click)="onBackdropClick()"></div>

<div class="personal-api-modal" [ngClass]="{ 'embedded-mode': isModalHostMode }" *ngIf="isModalOpen" role="dialog" aria-modal="true" aria-labelledby="personal-api-key-modal-title" (click)="$event.stopPropagation()">
  <div class="modal-shell">
    <div class="modal-header-row">
      <div>
        <h3 id="personal-api-key-modal-title" class="modal-title">PERSONAL API KEY</h3>
        <!-- Modified by Karanam on Oct 09 2026 to fix code review comment F-01 (spec 6.2): subtitle copy. Original: Manage API keys for connecting AI tools (Claude Desktop, Claude Code) to SSM NextGen on your behalf -->
        <p class="modal-subtitle">Manage API keys for connecting AI tools (Claude Desktop, Claude Code, and others) to SSM NextGen on your behalf.</p>
      </div>
      <!-- Modified by Karanam on Oct 09 2026 to fix code review comment F-01: FAQ link opens in a new tab so this dialog stays open. -->
      <!-- Modified by Karanam on Oct 09 2026 to fix code review comment UI request: FAQ link moved next to the close button; both are wrapped in .header-actions so they sit together on the right. Original (unwrapped, FAQ floated mid-header) kept below. -->
      <!--
      <a href="javascript:;" class="btn btn-link p-0 me-3 refresh-link" (click)="openFaq($event)">FAQ</a>
      <button type="button" class="modal-close-btn" aria-label="Close" (click)="closeModal()">&times;</button>
      -->
      <div class="header-actions">
        <a href="javascript:;" class="btn btn-link p-0 refresh-link" (click)="openFaq($event)">FAQ</a>
        <button type="button" class="modal-close-btn" aria-label="Close" (click)="closeModal()">&times;</button>
      </div>
    </div>

    <!-- Modified by Karanam on Oct 09 2026 to fix code review comment UI request: removed the sentence 'Do not share it or commit it.' from the banner below. -->
    <!-- Modified by Karanam on Oct 09 2026 to fix code review comment S-09/A-08: Generate, Revoke and the label/expiry inputs are disabled via canGenerateKey / canRevokeKey (function 564 CreateRight / DeleteRight); the list needs ViewRight. -->
    <div class="info-banner">
      <span class="info-marker">i</span>
      <!-- Modified by Karanam on Oct 09 2026 to fix code review comment F-01 (spec 6.2): info box copy. Original: Your API key authenticates you when AI tools access SSM data. It carries your existing facility permissions - you cannot access facilities you do not have access to in SSM. Treat this key like a password. -->
      <!-- Modified by Karanam on Oct 09 2026 to fix code review comment UI request: removed ', or commit it to source control' from the banner. Original: Your API key identifies you when an AI tool accesses SSM data. It carries your existing facility and feature permissions &mdash; it cannot see anything you can't already see in SSM. Treat this key like a password: don't share it, paste it into chat messages, or commit it to source control. -->
      Your API key identifies you when an AI tool accesses SSM data. It carries your existing facility and feature permissions &mdash; it cannot see anything you can't already see in SSM. Treat this key like a password: don't share it or paste it into chat messages.
    </div>

    <div class="modal-content-scroll">
      <div class="card section-card mb-3">
        <div class="card-body">
          <h5 class="card-title">Generate New Key</h5>
          <div class="generate-grid">
            <div>
              <label for="tokenLabel" class="field-label">KEY LABEL</label>
              <input
                id="tokenLabel"
                type="text"
                maxlength="100"
                class="form-control"
                [(ngModel)]="tokenLabel"
                [disabled]="!canGenerateKey"
                placeholder="e.g. &ldquo;Claude Desktop &mdash; work laptop&rdquo;" />
            </div>
            <div>
              <!-- Modified by Karanam on Oct 09 2026 to fix code review comment UI request: helper text moved to the top of the Expires After control (above its label) so the label, dropdown and the other controls stay aligned (grid uses align-items: end). Original position was below the select, with class mt-1 (kept below, commented). -->
              <div class="field-helper text-muted small mb-1">All keys expire and must be renewed. Choose the shortest duration that&apos;s practical for how you&apos;ll use this key.</div>
              <label for="expirySelection" class="field-label">EXPIRES AFTER</label>
              <select id="expirySelection" class="form-select" [(ngModel)]="expirySelection" [disabled]="!canGenerateKey">
                <option *ngFor="let option of expiryOptions" [value]="option.value">{{ option.label }}</option>
              </select>
              <!-- Modified by Karanam on Oct 09 2026 to fix code review comment F-01 (spec 6.2): helper text under Expires After. -->
              <!-- <div class="field-helper text-muted small mt-1">All keys expire and must be renewed. Choose the shortest duration that&apos;s practical for how you&apos;ll use this key.</div> -->
            </div>
            <div class="action-cell">
              <button type="button" class="btn btn-primary generate-btn" [disabled]="isGenerating || !canGenerateKey" (click)="generateToken()">
                {{ isGenerating ? 'Generating...' : 'Generate Key' }}
              </button>
            </div>
          </div>

          <div *ngIf="generatedToken" class="key-output-wrap mt-3">
                        <!-- Modified by Karanam on Oct 09 2026 to fix code review comment F-01 (spec 6.2): reveal title copy. Original: KEY GENERATED - COPY NOW, THIS IS THE ONLY TIME IT WILL BE SHOWN -->
            <div class="key-alert-title">Key generated &mdash; copy it now. This is the only time it will be shown.</div>
            <div class="key-row">
              <div class="token-value key-token">{{ generatedToken }}</div>
              <button type="button" class="btn copy-btn" (click)="copyToken()">Copy Key</button>
            </div>
                        <!-- Modified by Karanam on Oct 09 2026 to fix code review comment F-01 (spec 6.2): reveal warning copy. Original: This key cannot be retrieved after you leave this page. Copy it now. -->
            <div class="key-warning">This key cannot be retrieved once you leave this page. If you lose it, you'll need to revoke it and generate a new one.</div>

            <!-- Modified by Karanam on Oct 09 2026 to fix code review comment B-05: removed the Claude Desktop config snippet; it was non-functional (no server URL) and the server URL is shared with the client separately.
            <div class="snippet-title mt-3">CLAUDE DESKTOP CONFIG SNIPPET</div>
            <div class="key-row">
              <div class="token-value key-snippet">{{ claudeConfigSnippet }}</div>
              <button type="button" class="btn copy-btn" (click)="copyClaudeConfigSnippet()">Copy</button>
            </div>
            -->

          </div>
        </div>
      </div>

      <div class="card section-card">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="card-title mb-0">Active Keys</h5>
            <button type="button" class="btn btn-link p-0 refresh-link" [disabled]="isLoading" (click)="loadTokens()">Refresh</button>
          </div>

          <!-- Modified by Karanam on Oct 09 2026 to fix code review comment S-09/A-08: message for users without View on function 564. -->
                    <!-- Modified by Karanam on Oct 09 2026 to fix code review comment F-01 (spec 6.2): disabled-access copy. Original: You do not have rights to View personal API keys. -->
          <div class="text-muted" *ngIf="!canViewKeys">AI tool access is currently disabled for your account. Contact your administrator if you believe this is unexpected.</div>

          <div class="text-muted" *ngIf="isLoading">Loading keys...</div>

          <div class="table-responsive" *ngIf="!isLoading && canViewKeys">
            <table class="table table-hover align-middle mb-0" *ngIf="tokens && tokens.length; else emptyState">
              <thead>
                <tr>
                  <th>LABEL</th>
                  <th>KEY</th>
                  <th>CREATED</th>
                  <th>EXPIRES</th>
                  <th>LAST USED</th>
                  <th>STATUS</th>
                  <th class="text-end">&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let token of tokens; trackBy: trackByTokenId">
                  <td>{{ token.Label }}</td>
                  <td class="masked-key">{{ maskKeyPrefix(token.TokenPrefix) }}</td>
                  <td>{{ formatDisplayDate(token.CreatedDate) }}</td>
                  <td>{{ formatDisplayDate(token.ExpiresDate) }}</td>
                  <td>{{ formatDisplayDate(token.LastUsedDate) }}</td>
                  <td>
                    <span class="status-pill" [ngClass]="{
                      'status-active': token.Status === 'Active',
                      'status-expired': token.Status === 'Expired',
                      'status-revoked': token.Status === 'Revoked'
                    }">
                      {{ token.Status | uppercase }}
                    </span>
                  </td>
                  <td class="text-end">
                    <button
                      type="button"
                      class="btn btn-sm revoke-btn"
                      [disabled]="token.Status !== 'Active' || revokingTokenId === token.TokenId || !canRevokeKey"
                      (click)="revokeToken(token)">
                      {{ revokingTokenId === token.TokenId ? 'Revoking...' : 'Revoke' }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <ng-template #emptyState>
                        <!-- Modified by Karanam on Oct 09 2026 to fix code review comment F-01 (spec 6.2): empty state copy. Original: No personal API keys found. -->
            <div class="text-muted">You haven't created a Personal API Key yet. Generate one above to connect Claude Desktop, Claude Code, or another AI tool to your SSM account.</div>
          </ng-template>
        </div>
      </div>

    </div>
  </div>
</div>
